import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Page, PageHeader, Rows } from '@/components/page'
import { BusinessMenuButton, BusinessSidebar } from '@/components/layout/BusinessSidebar'
import { BusinessOfficers } from '@/types'
import { Mail, Users } from 'lucide-react'

type Props = {
  business: { id: string; name: string }
  officers: BusinessOfficers
}

function OfficerCard({ title, email }: { title: string; email: string | null }) {
  return (
    <div className="border rounded-lg px-4 py-4">
      <div className="flex items-center gap-2 mb-2">
        <Users className="w-4 h-4 text-muted-foreground" />
        <h3 className="text-sm font-medium text-foreground">{title}</h3>
      </div>
      {email ? (
        <a
          href={`mailto:${email}`}
          className="inline-flex items-center gap-1.5 text-sm text-blue-600 hover:underline"
        >
          <Mail className="w-3.5 h-3.5" />
          {email}
        </a>
      ) : (
        <p className="text-sm text-muted-foreground">Not yet assigned</p>
      )}
    </div>
  )
}

export default function BusinessOfficersShow({ business, officers }: Props) {

  return (
    <DashboardLayout
      title="Officers"
      breadcrumbs={[
        { label: 'Businesses', href: 'businesses' },
        { label: business.name, href: `businesses/${business.id}` },
        { label: 'Officers' },
      ]}
      guide={<BusinessSidebar businessId={business.id} />}
      mobileGuide={<BusinessMenuButton businessId={business.id} />}
    >
      <Page>
      <PageHeader
        title={<>Officers</>}
        subtitle={<>Your dedicated compliance and support officers.</>}
      />

      <Rows>
        <OfficerCard title="Compliance officer" email={officers.compliance_officer?.email ?? null} />
        <OfficerCard title="Support officer" email={officers.support_officer?.email ?? null} />
      </Rows>
      </Page>
    </DashboardLayout>
  )
}
